import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import Icon from '~/components/Icon';
import * as S from './styles';

export default function GrassInfoColumn({
  data,
  icon,
  label,
  variableWidth,
  inColumn,
}) {
  const { t } = useTranslation();
  return (
    <S.GrassInfoColumn variablewidth={variableWidth} inColumn={inColumn}>
      <S.IconContainer inColumn={inColumn}>
        <Icon size={18} name={icon} color="white" />
      </S.IconContainer>
      <S.Content inColumn={inColumn}>
        <S.Label>{label}</S.Label>
        {typeof data === 'string' ? (
          <S.TextContent>{data}</S.TextContent>
        ) : (
          data.map(item => (
            <div key={v4()}>
              {item.grassName && (
                <S.TextContent
                  key={`grass-type-${item.grassName}`}
                >{`${item.grassName} ${item.percentage}%`}</S.TextContent>
              )}
              {(item.start || item.end) && (
                <div key={item.label}>
                  <S.TextContent pushTop>{t(item.label)}</S.TextContent>
                  <S.TextContent light>{`${
                    item.start ? item.start : '--:--'
                  } - ${item.end ? item.end : '--:--'}`}</S.TextContent>
                </div>
              )}
            </div>
          ))
        )}
      </S.Content>
    </S.GrassInfoColumn>
  );
}

GrassInfoColumn.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  icon: PropTypes.string,
  label: PropTypes.string,
  variableWidth: PropTypes.bool,
  inColumn: PropTypes.bool,
};

GrassInfoColumn.defaultProps = {
  data: '',
  icon: '',
  label: '',
  variableWidth: false,
  inColumn: false,
};
